import React, {useState, useEffect} from "react";
import AddNewButton from "../Buttons/AddNewButton";
import ViewButton from "../Buttons/ViewButton";
import FilterButton from "../Buttons/FilterButton";
import { db } from "../../firebase";
import {equalTo, onValue, ref, set, query, orderByChild, orderByValue, get, child, remove} from 'firebase/database';



const RouteTable = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [routes, setRoutes] = useState([]);
    // const currentTime = new Date().toLocaleString();
    var today = new Date(),
    currentTime = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    console.log('time =====>', currentTime)

    useEffect(() => {
        const fetchRoutes = async () => {
        try {
            const routeRefrence = await ref(db, 'routes');
            onValue(routeRefrence, (snapshot) =>{

                if (snapshot.exists) {
                const routesData = snapshot.val();
                const routesArray = Object.entries(routesData).map(([routeId, route]) => ({
                    id: routeId,
                    ...route,
                }));
                setRoutes(routesArray);
                setIsLoading(false);
                }
            })
        } catch (error) {
            console.error('Error retrieving routes:', error);
        }
        };

        fetchRoutes();
    }, []);


    const delRoute = async (id) =>{
        console.log(id);
        const routeRefrence = await ref(db, 'routes');
        const childRef = child(routeRefrence, id);
        await remove(childRef);
        console.log(`child ${id} is removed`)
    }
    
    // console.log(routes)
    return (
        <div className="max-w-screen-xl  mx-auto">
            <div className="flex items-center justify-between mb-2 routehead gap-x-10">
                <h3 className="mb-2 text-xl font-bold mx-3.5 tracking-tight text-gray-900 dark:text-white">Created Routes</h3>
            </div>
    
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 border-collapse" >
                    <thead class="text-s text-gray-700  bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sm:rounded-xl border-collapse: separate">
                        <tr className="sm:rounded-xl">
                            <th scope="col" class="px-6 py-3">
                                RouteId#
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Route Name
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Status
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Duration
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Distance
                            </th>
                            <th scope="col" class="px-6 py-3">
                                End Time
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <span class="sr-only">Edit</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading? <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">Loading...</td>
                            </tr>
                            :
                            <>
                                {routes ? routes.map((route) => (
                                    <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={route.id}>
                                    <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{route.id}</td>
                                    <td class="px-6 py-4">{route.directions.routes[0].summary}</td>
                                    <td class="px-6 py-4">{route.endDate !== currentTime ? "Active" : "Not Active"}</td>
                                    <td class="px-6 py-4">{route.duration.toFixed(2)} Mins</td>
                                    <td class="px-6 py-4">{route.distance.toFixed(2)} Km</td>

                                    {/* <td class="px-6 py-4">{route.directions.routes[0].legs[0].start_address}</td>
                                    <td class="px-6 py-4">{route.directions.routes[0].legs[0].start_address}</td> */}
                                    <td class="px-6 py-4">{route.endDate ? route.endDate: 'none'}</td>
                                    <td class="px-6 py-4 text-right">
                                        <a href="" onClick={(e)=>{
                                            e.preventDefault();
                                            const id = route.id;
                                            console.log(id)
                                            delRoute(id);
                                        }} class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Del</a>
                                    </td>
                                    {/* Add more table cells for additional route properties */}
                                    </tr>
                                )): <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">

                                    <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">No Routes Available</td>

                                </tr>
                                
                                }
                            </>
                        }
                        
                    </tbody>
                </table>
            </div>


        </div>
    )
}

export default RouteTable